export const SET_VIEWER_CAMPAIGNS = "SET_VIEWER_CAMPAIGNS";
